function generateClientDetails({ customer }) {
    const clientDetails = {
        formNumber: 1,
        data: [
            {
                formName: 'customer-reference',
                formLabel: 'ID:',
                formValue: `${(customer && customer.reference) || ''}`,
            },
            {
                formName: 'customer-first_name',
                formLabel: 'First Name:',
                formValue: `${(customer && customer.first_name) || ''}`,
            },
            {
                formName: 'customer-last_name',
                formLabel: 'Last Name:',
                formValue: `${(customer && customer.last_name) || ''}`,
            },
            {
                formName: 'customer-address_line_1',
                formLabel: 'Address Line 1:',
                formValue: `${(customer && customer.home_address && customer.home_address.address_line_1) || ''}`,
            },
            {
                formName: 'customer-address_line_2',
                formLabel: 'Address Line 2:',
                formValue: `${(customer && customer.home_address && customer.home_address.address_line_2) || ''}`,
            },
            {
                formName: 'customer-address_line_3',
                formLabel: 'Address Line 3:',
                formValue: `${(customer && customer.home_address && customer.home_address.address_line_3) || ''}`,
            },
            {
                formName: 'customer-city_region',
                formLabel: 'City/Region:',
                formValue: `${(customer && customer.home_address && customer.home_address.city_region) || ''}`,
            },
            {
                formName: 'customer-postcode',
                formLabel: 'Postcode:',
                formValue: `${(customer && customer.home_address && customer.home_address.postcode) || ''}`,
            },
            {
                formName: 'customer-telephone',
                formLabel: 'Telephone:',
                formValue: `${(customer && customer.home_address && customer.home_address.telephone) || ''}`,
            },
            {
                formName: 'customer-mobile',
                formLabel: 'Mobile:',
                formValue: `${(customer && customer.home_address && customer.home_address.mobile) || ''}`,
            },
        ]
    };

    return clientDetails;
}


function generateNoteDetails({ customer }) {
    const noteDetails = {
        formNumber: 2,
        data: [
            {
                formName: 'customer-special_note',
                formLabel: 'Specials:',
                formValue: `${(customer && customer.special_note) || ''}`,
            },
            {
                formName: 'customer-pick_note',
                formLabel: 'Picking:',
                formValue: `${(customer && customer.pick_note) || ''}`,
            },
            {
                formName: 'customer-dispatch_note',
                formLabel: 'Dispatch:',
                formValue: `${(customer && customer.dispatch_note) || ''}`,
            },
        ]
    };

    return noteDetails;
}


function generateDoctorDetails({ doctor, practice }) {
    const doctorDetails = {
        formNumber: 3,
        data: [
            {
                formName: 'doctor-first_name',
                formLabel: 'First Name:',
                formValue: `${(doctor && doctor.first_name) || ''}`,
            },
            {
                formName: 'doctor-last_name',
                formLabel: 'Last Name:',
                formValue: `${(doctor && doctor.last_name) || ''}`,
            },
            {
                formName: 'practice-address_line_1',
                formLabel: 'Address Line 1:',
                formValue: `${(practice && practice.address_line_1) || ''}`,
            },
            {
                formName: 'practice-address_line_2',
                formLabel: 'Address Line 2:',
                formValue: `${(practice && practice.address_line_2) || ''}`,
            },
            {
                formName: 'practice-address_line_3',
                formLabel: 'Address Line 3:',
                formValue: `${(practice && practice.address_line_3) || ''}`,
            },
            {
                formName: 'practice-city_region',
                formLabel: 'City/Region:',
                formValue: `${(practice && practice.city_region) || ''}`,
            },
            {
                formName: 'practice-postcode',
                formLabel: 'Postcode:',
                formValue: `${(practice && practice.postcode) || ''}`,
            },
            {
                formName: 'doctor-phone_no',
                formLabel: 'Telephone:',
                formValue: `${(doctor && doctor.phone_no) || ''}`,
            },
            {
                formName: 'practice-fax',
                formLabel: 'Fax:',
                formValue: `${(practice && practice.fax) || ''}`,
            },
            {
                formName: 'doctor-email',
                formLabel: 'Email:',
                formValue: `${(doctor && doctor.email) || ''}`,
            },
        ]
    };

    return doctorDetails;
}

function customerActiveOptions() {
    return [
        {
            label: 'Active',
            value: 1,
        },
        {
            label: 'Inactive',
            value: 0,
        },
        {
            label: 'All',
            value: null,
        },
    ];
}

export { generateClientDetails, generateNoteDetails, generateDoctorDetails, customerActiveOptions };
